import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/components/pages/LegalPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dee7fca0d68e48/node_modules/next/dist/client/link.js");
